import React, { ReactElement } from "react";
import "./Hero.scss";

export default function Hero(): ReactElement {
  return (
    <div className="hero">
      <div className="hero-content">
        <p>The go to place for exceptional restaurant and retails furniture.</p>
        <a href="#collection">Shop Now!</a>
      </div>
    </div>
  );
}
